import React from 'react';
// nodejs library that concatenates classes
import classNames from 'classnames';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import SectionTeam from './Sections/SectionTeam.jsx';
import aboutUsStyle from 'assets/jss/material-kit-pro-react/views/aboutUsStyle.jsx';

class AboutUsPage extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }
  render() {
    const { classes } = this.props;
    return (
      <div id="aboutUs">
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div className={classes.container}>
            <SectionTeam />
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(aboutUsStyle)(AboutUsPage);



// WEBPACK FOOTER //
// ./src/views/YogaPage/Sections/AboutUsPage/AboutUsPage.jsx